// extracted by mini-css-extract-plugin
export default {"statistics":"region-statistics_statistics__6uYW2","statistics_left":"region-statistics_statistics_left__2YUXe","statistics_right":"region-statistics_statistics_right__YxqJv"};